!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define([], e) : "object" == typeof exports ? exports.ReactPixel = e() : t.ReactPixel = e();
}(window, function () {
  return function (t) {
    var e = {};
    function n(o) {
      if (e[o]) return e[o].exports;
      var r = e[o] = {
        i: o,
        l: !1,
        exports: {}
      };
      return t[o].call(r.exports, r, r.exports, n), r.l = !0, r.exports;
    }
    return n.m = t, n.c = e, n.d = function (t, e, o) {
      n.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: o
      });
    }, n.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, n.t = function (t, e) {
      if (1 & e && (t = n(t)), 8 & e) return t;
      if (4 & e && "object" == typeof t && t && t.__esModule) return t;
      var o = Object.create(null);
      if (n.r(o), Object.defineProperty(o, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var r in t) n.d(o, r, function (e) {
        return t[e];
      }.bind(null, r));
      return o;
    }, n.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return n.d(e, "a", e), e;
    }, n.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, n.p = "", n(n.s = 0);
  }([function (t, e, n) {
    t.exports = n(1);
  }, function (t, e, n) {
    "use strict";

    function o(t) {
      return function (t) {
        if (Array.isArray(t)) {
          for (var e = 0, n = new Array(t.length); e < t.length; e++) n[e] = t[e];
          return n;
        }
      }(t) || function (t) {
        if (Symbol.iterator in Object(t) || "[object Arguments]" === Object.prototype.toString.call(t)) return Array.from(t);
      }(t) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance");
      }();
    }
    n.r(e);
    var r = !!window.fbq,
      i = !1,
      a = function a() {
        var t;
        if (i) {
          for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++) n[r] = arguments[r];
          (t = console).info.apply(t, o(["[react-facebook-pixel]"].concat(n)));
        }
      },
      c = function c() {
        var t;
        if (i) {
          for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++) n[r] = arguments[r];
          (t = console).info.apply(t, o(["[react-facebook-pixel]"].concat(n)));
        }
      },
      f = function f() {
        return r || a("Pixel not initialized before using call ReactPixel.init with required params"), r;
      },
      u = {
        autoConfig: !0,
        debug: !1
      };
    e.default = {
      init: function init(t) {
        var e,
          n,
          o,
          c,
          f,
          l,
          d = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          s = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : u;
        e = window, n = document, o = "script", e.fbq || (c = e.fbq = function () {
          c.callMethod ? c.callMethod.apply(c, arguments) : c.queue.push(arguments);
        }, e._fbq || (e._fbq = c), c.push = c, c.loaded = !0, c.version = "2.0", c.queue = [], (f = n.createElement(o)).async = !0, f.src = "https://connect.facebook.net/en_US/fbevents.js", (l = n.getElementsByTagName(o)[0]).parentNode.insertBefore(f, l)), t ? (!1 === s.autoConfig && fbq("set", "autoConfig", !1, t), fbq("init", t, d), r = !0, i = s.debug) : a("Please insert pixel id for initializing");
      },
      pageView: function pageView() {
        f() && (fbq("track", "PageView"), i && c("called fbq('track', 'PageView');"));
      },
      track: function track(t, e) {
        f() && (fbq("track", t, e), i && (c("called fbq('track', '".concat(t, "');")), e && c("with data", e)));
      },
      trackSingle: function trackSingle(t, e, n) {
        f() && (fbq("trackSingle", t, e, n), i && (c("called fbq('trackSingle', '".concat(t, "', '").concat(e, "');")), n && c("with data", n)));
      },
      trackCustom: function trackCustom(t, e) {
        f() && (fbq("trackCustom", t, e), i && (c("called fbq('trackCustom', '".concat(t, "');")), e && c("with data", e)));
      },
      trackSingleCustom: function trackSingleCustom(t, e, n) {
        f() && (fbq("trackSingle", t, e, n), i && (c("called fbq('trackSingleCustom', '".concat(t, "', '").concat(e, "');")), n && c("with data", n)));
      },
      grantConsent: function grantConsent() {
        f() && (fbq("consent", "grant"), i && c("called fbq('consent', 'grant');"));
      },
      revokeConsent: function revokeConsent() {
        f() && (fbq("consent", "revoke"), i && c("called fbq('consent', 'revoke');"));
      },
      fbq: function (t) {
        function e() {
          return t.apply(this, arguments);
        }
        return e.toString = function () {
          return t.toString();
        }, e;
      }(function () {
        if (f()) {
          for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) e[n] = arguments[n];
          fbq.apply(void 0, e), i && (c("called fbq('".concat(e.slice(0, 2).join("', '"), "')")), e[2] && c("with data", e[2]));
        }
      })
    };
  }]);
});